__turbopack_context__.v({
  "Bg": "MlimzW_Bg",
  "Chevron": "MlimzW_Chevron",
  "ChevronOpen": "MlimzW_ChevronOpen",
  "Divider": "MlimzW_Divider",
  "EventSubmissionPage": "MlimzW_EventSubmissionPage",
  "ImageContent": "MlimzW_ImageContent",
  "IsActive": "MlimzW_IsActive",
  "IsHidden": "MlimzW_IsHidden",
  "IsOpen": "MlimzW_IsOpen",
  "Language": "MlimzW_Language",
  "LanguageChevron": "MlimzW_LanguageChevron",
  "LanguageDropdown": "MlimzW_LanguageDropdown",
  "LanguageItem": "MlimzW_LanguageItem",
  "LanguageList": "MlimzW_LanguageList",
  "LanguageText": "MlimzW_LanguageText",
  "LanguageWrapper": "MlimzW_LanguageWrapper",
  "LinkContainer": "MlimzW_LinkContainer",
  "LogoContainer": "MlimzW_LogoContainer",
  "LogoLink": "MlimzW_LogoLink",
  "MegaMenu": "MlimzW_MegaMenu",
  "MegaMenuContainer": "MlimzW_MegaMenuContainer",
  "MegaMenuContent": "MlimzW_MegaMenuContent",
  "MegaMenuContentColumns": "MlimzW_MegaMenuContentColumns",
  "MegaMenuLink": "MlimzW_MegaMenuLink",
  "MegaMenuLinkArrow": "MlimzW_MegaMenuLinkArrow",
  "MegaMenuLinkItem": "MlimzW_MegaMenuLinkItem",
  "MegaMenuLinkText": "MlimzW_MegaMenuLinkText",
  "MegaMenuLinks": "MlimzW_MegaMenuLinks",
  "MegaMenuTitle": "MlimzW_MegaMenuTitle",
  "NavigationDesktop": "MlimzW_NavigationDesktop",
  "NavigationDesktopLink": "MlimzW_NavigationDesktopLink",
  "Overlay": "MlimzW_Overlay",
  "PinkOrange": "MlimzW_PinkOrange",
  "Root": "MlimzW_Root",
  "Title": "MlimzW_Title",
});
